import { iconSizes } from "@hubrise/react-components"
import * as React from "react"

import { ItemRenderProps } from "../types"

import { StyledHandle, HandleIcon } from "./Styles"

const MoveHandle = (itemRenderProps: ItemRenderProps): JSX.Element => {
  return (
    <StyledHandle {...itemRenderProps.dragHandleProps} tabIndex={-1}>
      <HandleIcon code="drag_indicator" size={iconSizes._20} {...itemRenderProps} />
    </StyledHandle>
  )
}

export default MoveHandle
